const globals = {
  borderRadius: {
    large: '20px',
    main: '7px',
    small: '5px',
  },
  boxShadow: {
    large: '2px 4px 20px rgba(0, 0, 0, 0.2)',
    main: '0 2px 6px rgba(0, 0, 0, 0.1)',
    narrow: '0 1px 4px rgba(0, 0, 0, 0.1)',
  },
  transition: {
    main: 'ease-in-out 0.25s',
  },
};

export default globals;
